/**
 * Geographic bounds for Slovenia
 * Format: [west, south, east, north] (min longitude, min latitude, max longitude, max latitude)
 * Used to restrict tile loading for Slovenia-specific data sources (DEM, hillshade)
 * and as the country extent of every map whose config carries no `bounds` key (#591).
 */
export const SLOVENIA_BOUNDS: [number, number, number, number] = [13.37, 45.42, 16.61, 46.88];

/**
 * Geographic bounds for Czechia, same format. The coverage of the ČÚZK
 * ortofoto basemap (#594); the Czech map row carries the same box in its
 * config `bounds` (migration 0540).
 */
export const CZECHIA_BOUNDS: [number, number, number, number] = [12.09, 48.55, 18.86, 51.06];

/**
 * Is the given coordinate inside a [west, south, east, north] box?
 * Used to reject junk EXIF GPS (0,0), stripped metadata, or out-of-country values
 * before they get written to sxdocs.geometry (issue #243). The box comes from the
 * map's country settings (`mapBounds` in map/countrySettings.ts), so a Czech map
 * accepts Czech photos and a Slovenian map keeps rejecting them.
 */
export function isInBounds(
  lng: number,
  lat: number,
  bounds: [number, number, number, number]
): boolean {
  if (lng === 0 && lat === 0) return false;
  const [w, s, e, n] = bounds;
  return lat >= s && lat <= n && lng >= w && lng <= e;
}
